import { environment } from "@env/environment";
import { authenticationInterceptor } from "@interceptors/auth.http-interceptor";
import { gobernanzaInterceptor } from "@interceptors/gobernanza.http-interceptor";
import { withNgxsReduxDevtoolsPlugin } from "@ngxs/devtools-plugin";
import { withNgxsStoragePlugin } from "@ngxs/storage-plugin";
import { provideStore } from "@ngxs/store";
import * as Sentry from "@sentry/angular";
import { CommonState } from "@state/common/common.state";
import { DefaultSettingsState } from "@state/default-settings/default-settings.state";
import { RoutesState } from "@state/routes/routes.state";
import { SessionState } from "@state/session/session.state";
import { UserState } from "@state/user/user.state";
import { recoverFromChunkLoadError } from "@utils/chunk-load-recovery.utils";

import { provideHttpClient, withInterceptors } from "@angular/common/http";
import {
  type ApplicationConfig,
  ErrorHandler,
  inject,
  LOCALE_ID,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from "@angular/core";
import {
  provideRouter,
  Router,
  withComponentInputBinding,
  withNavigationErrorHandler,
  withViewTransitions,
} from "@angular/router";

import { routes } from "./app.routes";
import { NotificationState } from "./shared/notifications/state/notification.state";

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    { provide: LOCALE_ID, useValue: "es-CL" },
    provideRouter(
      routes,
      withComponentInputBinding(),
      withNavigationErrorHandler(recoverFromChunkLoadError),
      withViewTransitions()
    ),
    provideHttpClient(
      withInterceptors([authenticationInterceptor, gobernanzaInterceptor])
    ),
    provideStore(
      [
        CommonState,
        UserState,
        SessionState,
        RoutesState,
        DefaultSettingsState,
        NotificationState,
      ],
      withNgxsStoragePlugin({ keys: "*" }),
      ...(!environment.PROD ? [withNgxsReduxDevtoolsPlugin()] : [])
    ),
    provideZonelessChangeDetection(),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      inject(Sentry.TraceService);
    }),
  ],
};
